import { UserNote_private } from './UserNotePopup.locstring.json';
import { observer } from 'mobx-react-lite';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { NoteEditView } from 'owa-notes';
import React from 'react';

const styles = require('./StickyNoteContainer.scss');
const classNames = require('classnames/bind').bind(styles);

const STICKY_NOTE_PREFIX = 'n-';
const STICKY_NOTE_CANVAS = 'n-noteCanvas';
const STICKY_NOTE_COLOR_CHARCOAL = 'Charcoal';

interface StickyNoteContainerProps {
    noteId: string;
    color: string;
    onSaveNote: () => void;
    onDeleteNote: () => void;
}

const StickyNoteContainer = observer(function StickyNoteContainer(props: StickyNoteContainerProps) {
    const { noteId, color, onSaveNote, onDeleteNote } = props;

    React.useEffect(() => {
        return () => {
            onSaveNote();
        };
    }, []);

    const renderNoteHeader = (): JSX.Element => {
        const textColorClassName =
            color === STICKY_NOTE_COLOR_CHARCOAL ? styles.textColorLight : styles.textColorDark;
        const backgroundColorClassName =
            color === STICKY_NOTE_COLOR_CHARCOAL
                ? styles.backgroundColorLight
                : styles.backgroundColorDark;

        return (
            <div className={classNames(styles.headerContainer, textColorClassName)}>
                <div className={styles.iconContainer}>
                    <Icon iconName={ControlIcons.Lock} />
                    {loc(UserNote_private)}
                </div>
                <ActionButton
                    className={classNames(
                        styles.actionButton,
                        textColorClassName,
                        backgroundColorClassName
                    )}
                    iconProps={{
                        iconName: ControlIcons.Delete,
                        styles: {
                            root: textColorClassName,
                        },
                    }}
                    onClick={onDeleteNote}
                />
            </div>
        );
    };

    const renderNoteEditContainer = (): JSX.Element => {
        return <NoteEditView className={styles.noteContainer} noteId={noteId} />;
    };

    return (
        <div className={classNames(STICKY_NOTE_PREFIX + color, STICKY_NOTE_CANVAS)}>
            {renderNoteHeader()}
            {renderNoteEditContainer()}
        </div>
    );
});

export default StickyNoteContainer;
